var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.has_match_page_store && _vm.has_store_data
    ? _c("div", { staticClass: "waf-matchtips fg-widget" }, [
        _vm.current_match
          ? _c(
              "div",
              [
                _c("top-tabs", { attrs: { current_match: _vm.current_match } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "waf-component roi-component waf-match-info" },
                  [
                    _vm.has_store_data
                      ? _c("div", { staticClass: "content-wrap" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.no_matches_active,
                                  expression: "!no_matches_active",
                                },
                              ],
                              staticClass: "waf-body",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "tab-content lazy-bg" },
                                [
                                  _vm.hasMatchInfoData
                                    ? _c("info-feed")
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.is_loading
                            ? _c("div", { staticClass: "fg-preloader-wrap" }, [
                                _c("div", { staticClass: "fg-preloader" }),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("contest-widget", {
                  attrs: {
                    current_match: _vm.current_match,
                    showInLHS: false,
                    storeName: "customTipsWidget",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }